//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalScoring'
};
